import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Supplier } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class SupplierService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getSupplier(id, schema = { id: null, name: null }): Promise<Supplier> {
    return new Supplier(await this.core.services.supplier.getById(id, schema))
  }

  async getSuppliers(
    parameters: any = { sort: 'name', direction: 'asc' },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: Supplier[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.supplier.getList(parameters, schema)
  }

  createSupplier(supplier: Partial<Supplier>, schema: Partial<Supplier>): Promise<Supplier> {
    return this.core.services.supplier.create(supplier, schema)
  }

  updateSupplier(supplier: Partial<Supplier>, schema: Partial<Supplier>): Promise<Supplier> {
    return this.core.services.supplier.update(supplier, schema)
  }

  deleteSupplier(supplier: Partial<Supplier>): Promise<unknown[] | null | undefined> {
    return this.core.services.supplier.delete(supplier)
  }
}
